<template>

	<div id="developerIndex">
		<div class="wrap container-fluid">
			<div class="row">
				<div class="menu_left">
					<div class="menu_top menu_top_img">
						<!--<img src="" alt="" />-->
						<p class="text-center">
							<img src="../assets/images/logo-register-info.png" alt="" />
						</p>
						<p class="text-center">开发者管理中心</p>
					</div>
				</div>
				<div class="container_right p_background">
					<div class="container_right_info">
						<section class="container_btm">
							<div class="clearfix tb_padding">
								<p class="text-center h3">
									<img src="../assets/images/icon-individual-developers-t.png" class="margin_r_7" alt="" />
									注册个人开发者</p>
								<div class="container_box">
									<h4 class="message_title">
							    		<span>基本信息</span>
							    		<span class="endnote">
							    			账号名称:
							    			<i>{{mob}}</i>
							    		</span>
							    	</h4>
									<section class="partition_message developer_box publick_form_box developer_basic_box">

										<!--手机号码-->
										<section class="form_box">
											<label class="form_label" for="">手机号码：</label>
											<input type="hidden" v-model="tCloudUserDeveloper.mobile" />
											<span>{{mob}}</span>
										</section>

										<!--开发者姓名-->
										<section class="form_box">
											<label class="form_label" for="">开发者姓名：</label>
											<input type="text" class="form-control form_control" id="register_name" placeholder="请输入开发者姓名" v-model.trim="tCloudUserDeveloper.developerName" />
											<p class="prompt_msg">
												<small class="tip_sub_text">
						        					（请与身份证信息保持一致）
						        				</small>
											</p>
										</section>

										<!--证件类型及编号-->
										<section class="form_box">
											<label class="form_label" for="">证件编号类型及编号：</label>
											<select class="form-control form_control form_select" name="" id="register_cardtype" v-model.trim="tCloudUserDeveloper.cardType" @change="changeType">
												<option value="">请选择</option>
												<option v-for="cardoption in cardOptions" v-bind:value="cardoption.id">
													{{ cardoption.dictionaryname }}
												</option>
											</select>
											<input type="text" class="form-control form_control" id="register_cardno" @focus="checkCardType" @blur="checkOnly()" placeholder="请输入证件编号" v-model.trim="tCloudUserDeveloper.cardNo" />
											<p class="prompt_msg">
												<small class="tip_sub_text">
						        					（国内开发者请填写15位或18位大陆身份证号码，国外开发者请填写护照号码）
						        				</small>
											</p>
										</section>

										<!--上传证件照-->
										<section class="form_box">
											<label class="form_label" for="">上传证件照：</label>
											<small class="tip_sub_text">
					        					（jpg、png格式的图片，且不超过1M）
					        				</small>
										</section>
										<section id="huzhao" class="id_card_box line_block">
											<form id="subformhz" class="inline-block" enctype="multipart/form-data" method="post" action="/zklccloud/uploadImages">
												<input type="hidden" name="type" value="0" />
												<input type="hidden" id="cardImg" readonly="readonly" />
												<div class="left pos-relative file_box_btn text-center" id="echoImgz">
													<input type="file" name="file" @change="uploadPhoto()" id="register_imgFile" class="cursor" />
													<img :src="echoImg" class="img_font" alt="" title="" />
													<span class="id_card_text id_card_text_hide">点击上传证件照</span>
												</div>
											</form>
										</section>
										<section class="id_card_box line_block" id="shenfenzheng">
											<form id="subform" class="inline-block" enctype="multipart/form-data" method="post" action="/zklccloud/uploadImages">
												<input type="hidden" name="type" value="0" />
												<input type="hidden" id="cardPhoto" readonly="readonly" />
												<div class="left pos-relative file_box_btn text-center" id="echoImgz">
													<input type="file" name="file" @change="uploadPhotoz()" id="register_imgFilez" class="cursor" />
													<img :src="echoImg" class="img_font" alt="" title="" />
													<span class="id_card_text id_card_text_hidd">点击上传证件照正面</span>
												</div>
											</form>
											<form id="subform1" class="inline-block" enctype="multipart/form-data" method="post" action="/zklccloud/uploadImages">
												<input type="hidden" name="type" value="0" />
												<input type="hidden" id="cardPhoto1" readonly="readonly" />
												<div class="left pos-relative file_box_btn text-center" id="echoImgf">
													<input type="file" name="file" @change="uploadPhotof()" id="register_imgFilef" class="cursor" />
													<img :src="echoImg1" class="img_font" alt="" title="" />
													<span class="id_card_text id_card_text_hid">点击上传证件照背面</span>
												</div>
											</form>
										</section>

									</section>
								</div>

								<!--结算方式-->
								<div class="container_box">
									<h4 class="message_title">
							    		<span>结算方式</span>
							    		<span class="endnote"><i class="must_color">*</i>为必填项</span>
							    	</h4>
									<section class="partition_message developer_box publick_form_box developer_basic_box">

										<!--开户行-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>开户行：</label>
											<select class="form-control form_control form_select" name="" id="bankNum" style="width: 260px;" v-model.trim="tCloudUserBankcard.bankNum">
												<option disabled="disabled" value="">请选择开户行</option>
												<option v-for="bankoption in bankOptions" v-bind:value="bankoption.id">
													{{ bankoption.dictionaryname }}
												</option>
											</select>
										</section>
										
										<!--开户支行-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>开户支行：</label>
											<input type="text" class="form-control form_control" placeholder="请输入开户支行" id="bankBranch" maxlength="40" v-model.trim="tCloudUserBankcard.bankBranch"/>
											<p class="prompt_msg">
												<small class="tip_sub_text">
						        					（请务必正确填写开户支行）
						        				</small>
											</p>
										</section>

										<!--卡号-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>卡号：</label>
											<input type="text" class="form-control form_control" placeholder="请输入银行卡号" id="bankCardNo" v-model.trim="tCloudUserBankcard.cardNo"/>
										</section>

										<!--姓名-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>姓名：</label>
											<input type="text" class="form-control form_control" placeholder="请输入开户人姓名" id="cardUsername" maxlength="20" v-model.trim="tCloudUserBankcard.cardUsername"/>
										</section>
									</section>
								</div>

								<!--联系方式-->
								<div class="container_box">
									<h4 class="message_title">
							    		<span>联系方式</span>
							    		<span class="endnote"><i class="must_color">*</i>为必填项</span>
							    	</h4>
									<section class="partition_message developer_box publick_form_box developer_basic_box">

										<!--联系地址-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>联系地址：</label>
											<select class="form-control form_control form_select" name="" id="register_addressprovince" v-model="tCloudUserDeveloper.addressProvince" @change="queryProvinceCity('0','0',$event)">
												<option value="">请选择</option>
												<option v-for="option in provinceOptions" v-bind:value="option.id">
													{{ option.dictionaryname }}
												</option>
											</select>
											<select class="form-control form_control form_select" name="" id="register_addresscity" v-model="tCloudUserDeveloper.addressCity" @change="queryProvinceCity('0','1',$event)">
												<option value="">请选择</option>
												<option v-for="cityoption in cityOptions" v-bind:value="cityoption.id">
													{{ cityoption.dictionaryname }}
												</option>
											</select>
											<select class="form-control form_control form_select" name="" id="register_addressstreet" v-model="tCloudUserDeveloper.addressStreet" @change="queryProvinceCity('0','2',$event)">
												<option value="">请选择</option>
												<option v-for="streetoption in streetOptions" v-bind:value="streetoption.id">
													{{ streetoption.dictionaryname }}
												</option>
											</select>
											<input type="text" class="form-control form_control" id="register_addressdetail" placeholder="请请输入详细地址" v-model="tCloudUserDeveloper.addressDetails" />
											<p class="prompt_msg">
												<small class="tip_sub_text">
						        					（请填写详细联系地址）
						        				</small>
											</p>
										</section>

										<!--电子邮箱-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>电子邮箱：</label>
											<input type="text" class="form-control form_control" id="register_email" placeholder="请输入电子邮箱" v-model="tCloudUserDeveloper.email" />
											<p class="prompt_msg">
												<small class="tip_sub_text">（用于接收合作邮件及审核通知等重要信息）</small>
											</p>
										</section>

										<!--手机号码-->
										<section class="form_box">
											<label class="form_label" for=""><i class="must_color">*</i>手机号码：</label>
											<span>{{mob}}</span>
										</section>

										<!--其他号码-->
										<section class="form_box">
											<label class="form_label" for="">其他手机或电话号码：</label>
											<input type="text" class="form-control form_control" id="register_spare" placeholder="区号请以“-”分隔" v-model.trim="tCloudUserDeveloper.spareMobile" />
											<p class="prompt_msg">
												<small class="tip_sub_text">（备用联系电话,同样不会对外公布,仅作通知使用）</small>
											</p>
										</section>

										<!--QQ-->
										<section class="form_box">
											<label class="form_label" for="">QQ：</label>
											<input type="text" class="form-control form_control" id="register_qq" placeholder="请输入QQ号码" v-model.trim="tCloudUserDeveloper.qq" />
											<p class="prompt_msg">
												<small class="tip_sub_text">（方便在线实时沟通）</small>
											</p>
										</section>

										<!--官网地址-->
										<section class="form_box">
											<label class="form_label" for="">官网地址：</label>
											<input type="text" class="form-control form_control" id="register_blog" placeholder="请输入官网地址" v-model.trim="tCloudUserDeveloper.blogUrl" />
										</section>

									</section>
								</div>
								<!-- container_box/ -->

								<div class="developer_register_btn text-center">
									<div class="issue_time_radio tip_sub_text">
										<input type="checkbox" checked class="radio_input_f" name="radio_issue_time" id="developer_register_radio" />
										<label class="form_label radio_label" for="developer_register_radio"></label>
										<span>我已阅读并同意<a class="cursor btn_a" target="_blank" @click="goAgreeMent">《开发者用户服务协议》</a></span>
									</div>
									<p>
										<span class="btn btn_issue" @click="frc">注册</span>
									</p>
								</div>

							</div>
						</section>
						<!-- container_btm/ -->
					</div>
				</div>
			</div>
		</div>

		<input type="hidden" v-model="pushRoute" />

		<!--协议弹出-->
		<transition name="slides-fade" mode="out-in">
			<v-a-modal v-if="infoFlage" title="协议详情" linkSrc="/agreement_register" @modalOff="infoFlage = !infoFlage"></v-a-modal>
		</transition>
	</div>

</template>

<script>
	import { MessageBox } from 'element-ui'
	import VAModal from './agreement_modal'
	export default {
		name: 'developer_register',
		components: {
			VAModal
		},
		data() {
			return {
				infoFlage: false,
				pushRoute: '',
				cardOptions: "",
				provinceOptions: "",
				cityOptions: "",
				streetOptions: "",
				bankOptions: "",
				echoImg: "", //回显证件照
				echoImg1: "", //回显证件照
				tCloudUserDeveloper: {
					developerName: "",
					cardType: "",
					cardNo: "",
					photoPath: "",
					photoPathNegative: "",
					addressDetails: "",
					addressProvince: "",
					addressCity: "",
					addressStreet: "",
					email: "",
					mobile: this.$route.params.mobile,
					spareMobile: "",
					qq: "",
					blogUrl: ""
				},
				tCloudUserBankcard: {
					bankNum: '',
					cardNo: '',
					bankBranch: '',//开户支行
					cardUsername: '',
				},
				mob: this.$route.params.mobile
			}
		},
		created: function() {
			this.getSystemConfigList();
			this.initelephoto();
			this.getAllProvinceList();
		},
		computed: {

		},
		mounted: function() {
			this.$nextTick(function() {
				$("#shenfenzheng").show();
				$("#huzhao").hide();
			})
		},
		methods: {
			getSystemConfigList() {
				var temp = this;
				this.$http.post('/zklccloud/queryAllTCloudSysDictionary', {
					emulateJSON: true
				}).then(function(m) {
					for(var key in m.body.dictionaryMap) {
						if(key == '身份类型'){
							temp.cardOptions = m.body.dictionaryMap[key];
						}else if(key == '开户行'){
							temp.bankOptions = m.body.dictionaryMap[key];
						}
						//							else if(key == '城市')
						//							{
						//								temp.cityOptions = m.body.dictionaryMap[key];
						//							}

					}
				})
			},
			getAllProvinceList() {
				var temp = this;
				this.$http.post('/zklccloud/findAllProvinceList', {
					emulateJSON: true
				}).then(function(m) {
					temp.provinceOptions = m.body.content.provinceList;
				})
			},
			queryProvinceCity(code, level, e) {
				var temp = this;
				e = window.event || e;
				var obj = e.srcElement ? e.srcElement : e.target;
				if("" != obj.value) {
					$.ajax({
						url: "/zklccloud/queryProvinceCity",
						type: "post",
						data: {
							"code": obj.value
						},
						async: false,
						dataType: "json",
						success: function(data) {
							//组装数据
							if(level == "0") {
								temp.cityOptions = data.content.provinceCityList;
							} else if(level == "1") {
								temp.streetOptions = data.content.provinceCityList;
							}
						}
					});
				} else {
					if(level == "0") {
						temp.cityOptions = "";
					} else if(level == "1") {
						temp.streetOptions = "";
					}
				}
			},
			changeType() {
				this.tCloudUserDeveloper.cardNo = '';
				if($("#register_cardtype").find("option:selected").val() == "105002") {
					this.echoImg = '';
					this.echoImg1 = '';
					this.tCloudUserDeveloper.photoPath ='';
					this.tCloudUserDeveloper.photoPathNegative ='';
					$("#shenfenzheng").hide();
					$("#huzhao").show();
					$(".id_card_text_hide").show();
					$("#cardPhoto").val("");
					$("#cardPhoto1").val("");
				}else if($("#register_cardtype").find("option:selected").val() == "105001"){
					this.echoImg = '';
					this.echoImg1 = '';
					this.tCloudUserDeveloper.photoPath ='';
					this.tCloudUserDeveloper.photoPathNegative ='';
					$("#shenfenzheng").show();
					$("#huzhao").hide();
					$(".id_card_text_hid").show();
					$(".id_card_text_hidd").show();
					$("#cardImg").val("");
				}
			},
			initelephoto() {
				if(typeof(this.$route.params.mobile) == "undefined") {
					this.$http.post('/zklccloud/queryUser',{ emulateJSON: true }).then(function(m) {
					this.mob=m.body.content.mob;
					this.tCloudUserDeveloper.mobile = m.body.content.mob;
					})
				}
			},
			uploadPhoto: function() {
				var temp = this;
				$("#subformhz").ajaxSubmit(function(data) {
					var urk = data.content.filepath;
					var urlk = urk.split("#")[1];
					if(data.resultCode == '-1') {
						if(urlk == "nottype") {
							MessageBox('格式错误，请上传图片格式文件！', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							$("input[name='file']").val("");
							return
						} else if(urlk == "tobig") {
							MessageBox('文件过大，请上传小于1M图片文件！', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							$("input[name='file']").val("");
							return
						}
					} else if(data.resultCode == '0') {
						$(".id_card_text_hide").hide();
						MessageBox('上传成功！', '提示', 'success', {
							confirmButtonText: '确定',
						}).then(() => {});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						$("#cardImg").val("已上传");
						temp.echoImg = urk;
						temp.tCloudUserDeveloper.photoPath = urk;
					} else {
						MessageBox('操作失败！', '提示', 'error', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
					}
				});
			},
			uploadPhotoz: function() {
				var temp = this;
				$("#subform").ajaxSubmit(function(data) {
					var urk = data.content.filepath;
					var urlk = urk.split("#")[1];
					if(data.resultCode == '-1') {
						if(urlk == "nottype") {
							MessageBox('格式错误，请上传图片格式文件！', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							$("input[name='file']").val("");
							return
						} else if(urlk == "tobig") {
							MessageBox('文件过大，请上传小于1M图片文件！', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							$("input[name='file']").val("");
							return
						}
					} else if(data.resultCode == '0') {
						$(".id_card_text_hidd").hide();
						MessageBox('上传成功！', '提示', 'success', {
							confirmButtonText: '确定',
						}).then(() => {});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						$("#cardPhoto").val("已上传");
						temp.echoImg = urk;
						temp.tCloudUserDeveloper.photoPath = urk;
					} else {
						MessageBox('操作失败！', '提示', 'error', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
					}
				});
			},
			uploadPhotof: function() {
				var temp = this;
				$("#subform1").ajaxSubmit(function(data) {
					var urk = data.content.filepath;
					var urlk = urk.split("#")[1];
					if(data.resultCode == '-1') {
						if(urlk == "nottype") {
							MessageBox('格式错误，请上传图片格式文件！', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							$("input[name='file']").val("");
							return
						} else if(urlk == "tobig") {
							MessageBox('文件过大，请上传小于1M图片文件！', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							$("input[name='file']").val("");
							return
						}
					} else if(data.resultCode == '0') {
						$(".id_card_text_hid").hide();
						MessageBox('上传成功！', '提示', 'success', {
							confirmButtonText: '确定',
						}).then(() => {});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						$("#cardPhoto1").val("已上传");
						temp.echoImg1 = urk;
						temp.tCloudUserDeveloper.photoPathNegative = urk;
					} else {
						MessageBox('操作失败！', '提示', 'error', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
					}
				})
			},
			checkCardType(){
				if($("#register_cardtype").find("option:selected").val() == "") {
					MessageBox('请选择证件类型', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				}
			},
			checkOnly() {
				/*if($("#register_cardtype").find("option:selected").val() == "") {
					MessageBox('请选择证件类型', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else */if($("#register_cardtype").find("option:selected").val() == "105001") {
					var formData = this.tCloudUserDeveloper.cardNo;
					if(formData) {
						this.$http.post('/zklccloud/checkOnlyForCard', {
							"cardNo": formData
						}, {
							emulateJSON: true
						}).then(function(m) {
							if(m.body.resultCode != 0) {
								MessageBox('您输入的证件号已被注册,请重新输入', '提示', 'warning', {
									confirmButtonText: '确定',
								})

								if($(".el-message-box__btns")) {
									$(".el-message-box__btns").attr("id", "btnSub");
								}
								this.tCloudUserDeveloper.cardNo = '';
								return false;
							}
						})
					}
				}
			},
			//跳转条款页
			goAgreeMent() {
				//				this.$router.push({ name: 'agreement_register' });
				this.infoFlage = true;
				if(this.infoFlage) {
					$("body").css("overflow", "hidden")
				}
			},
			//body设置
			frc: function() {

				var registername = $("#register_name"),
					cardno = $("#register_cardno"),
					addressdetail = $("#register_addressdetail"),
					email = $("#register_email"),
					spare = $("#register_spare"),
					qq = $("#register_qq"),
					blog = $("#register_blog"),
					selectcardtype = $("#register_cardtype"), //选择证件类型
					addressprovince = $("#register_addressprovince"), //选择省份
					addresscity = $("#register_addresscity"), //选择城市
					addressstreet = $("#register_addressstreet"), //选择城市
					registeradio = $("#developer_register_radio"),
					cardphotoUrl = $("#cardPhoto"),
					cardphotoUrl1 = $("#cardPhoto1"),
					bankNum = $("#bankNum"), bankBranch = $("#bankBranch"), bankCardNo = $("#bankCardNo"), cardUsername = $("#cardUsername"),
					cardImg = $("#cardImg");
				if(!/^([\u4E00-\u9FA5A-Za-z]{1,20})+$/.test(registername.val())) {
					MessageBox('开发者姓名只允许中英文,限20个字符', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						registername.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(selectcardtype.find("option:selected").val() == "") {
					MessageBox('请选择证件类型', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if("" == cardno.val()) {
					MessageBox('请输入证件号', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						cardno.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(!isIdCardNo(cardno.val())) {
					MessageBox('请输入正确的证件号', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						cardno.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(selectcardtype.find("option:selected").val() == "105001" && cardphotoUrl.val() == ""){
					MessageBox('请上传证件照正面', '提示', 'warning', {
						confirmButtonText: '确定',
					})
					
					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(selectcardtype.find("option:selected").val() == "105001" && cardphotoUrl.val() != "" && cardphotoUrl1.val() == ""){
					MessageBox('请上传证件照背面', '提示', 'warning', {
						confirmButtonText: '确定',
					})
					
					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(selectcardtype.find("option:selected").val() == "105002" && cardImg.val() == "") {
					MessageBox('请上传证件照', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				}else if(bankNum.find("option:selected").val() == "") {
					MessageBox('请选择开户行', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if("" == bankBranch.val()) {
					MessageBox('请输入开户支行', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						bankBranch.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if("" == bankCardNo.val()) {
					MessageBox('请输入银行卡号', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						bankCardNo.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(!/^([0-9]{16}|[0-9]{19})$/.test(bankCardNo.val())) {
					MessageBox('请输入正确的银行卡号', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						bankCardNo.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(!/^([\u4E00-\u9FA5A-Za-z\s]{1,20})+$/.test(cardUsername.val())) {
					MessageBox('请输入正确的开户人姓名', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						cardUsername.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(addressprovince.find("option:selected").val() == "") {
					MessageBox('请选择所在省份', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(addresscity.find("option:selected").val() == "") {
					MessageBox('请选择所在城市', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(addressstreet.find("option:selected").val() == "") {
					MessageBox('请选择所在街镇', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if("" == addressdetail.val()) {
					MessageBox('请输入详细联系地址', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						addressdetail.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if("" != addressdetail.val() && addressdetail.val().length > 30) {
					MessageBox('详细地址最多输入30个字符', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						addressdetail.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				} else if(!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(email.val())) {
					MessageBox('请输入正确的邮箱格式', '提示', 'warning', {
						confirmButtonText: '确定',
					}).then(() => {
						email.focus();
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				}
				if("" != spare.val()) {
					if(!checkTel(spare.val())) {
						MessageBox('请输入正确的联系方式,座机区号以“-”分隔', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							spare.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return
					}
				}
				if("" != qq.val()) {
					if(!/^\d{5,10}$/.test(qq.val())) {
						MessageBox('请输入正确的QQ号码', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							qq.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return
					}
				}
				if("" != blog.val()) {
					if(!/(http[s]?|ftp):\/\/[^\/\.]+?\..+\w$/i.test(blog.val())) {
						MessageBox('官网地址必须以http(s)开头', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							blog.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return
					}
				}
				if($("input[type='checkbox']:checked").length == 0) {
					MessageBox('请阅读并同意《开发者用户服务协议》', '提示', 'warning', {
						confirmButtonText: '确定',
					})

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return
				}
                var parameter = {
					"tCloudUserDeveloper": this.tCloudUserDeveloper,
					"tCloudUserBankcard": this.tCloudUserBankcard
				};

				var temp = this;
				this.$http.post('/zklccloud/createPersonalDev', JSON.stringify(parameter), {emulateJSON: true}).then(function(m) {
					if(m.body.resultCode == '0'){
						localStorage.setItem('loginUserType', "101005");
							MessageBox('操作成功', '提示', 'success', {
								confirmButtonText: '确定',
							}).then(()=>{
								this.$router.push({
									name: 'app_index'
							})
						})
					} else if(m.body.resultCode == '-1'){
						MessageBox('注册失败，请联系管理员', '提示', 'warning', {
							confirmButtonText: '确定',
						})
					}

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
				})

			},
			routePush() {
				var temp = this;
				$("#one").find(".state_text").html("");
				this.tipMsg = "";
				setTimeout(function() {
					temp.trueFlag = false;
					temp.falseFlag = false;
				}, 300)
				if(this.pushRoute == "1") {
					this.$router.push({
						name: 'app_index'
					})
				}
			}
		}
	}

	//身份证号校验
	function isIdCardNo(num) {
		if($("#register_cardtype").find("option:selected").val() == "105001") {

			var factorArr = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4,
				2, 1);
			var error;
			var varArray = new Array();
			var intValue;
			var lngProduct = 0;
			var intCheckDigit;
			var intStrLen = num.length;
			var idNumber = num;
			// initialize
			if((intStrLen != 15) && (intStrLen != 18)) {
				//error = "输入身份证号码长度不对！";
				//frmAddUser.txtIDCard.focus();
				return false;
			}
			// check and set value
			for(var i = 0; i < intStrLen; i++) {
				varArray[i] = idNumber.charAt(i);
				if((varArray[i] < '0' || varArray[i] > '9') && (i != 17)) {
					//error = "错误的身份证号码！.";
					//frmAddUser.txtIDCard.focus();
					return false;
				} else if(i < 17) {
					varArray[i] = varArray[i] * factorArr[i];
				}
			}
			if(intStrLen == 18) {
				//check date
				var date8 = idNumber.substring(6, 14);
				if(true == false) { //
					//error = "身份证中日期信息不正确！.";
					return false;
				}
				// calculate the sum of the products
				for(i = 0; i < 17; i++) {
					lngProduct = lngProduct + varArray[i];
				}
				// calculate the check digit
				intCheckDigit = 12 - lngProduct % 11;
				switch(intCheckDigit) {
					case 10:
						intCheckDigit = 'X';
						break;
					case 11:
						intCheckDigit = 0;
						break;
					case 12:
						intCheckDigit = 1;
						break;
				}
				// check last digit
				if(varArray[17].toUpperCase() != intCheckDigit) {
					//error = "身份证效验位错误!...正确为： " + intCheckDigit + ".";
					return false;
				}
			} else { //length is 15
				//check date
				var date6 = idNumber.substring(6, 12);
				if(checkDate(date6) == false) {
					return false;
				}
			}
			return true;
		} else {
			return true;
		}
	}

	//联系方式校验
	function checkTel(value) {
		var isMobile = /^(?:13\d|14\d|15\d|18\d|17\d)\d{5}(\d{3}|\*{3})$/;
		var isPhone = /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/;
		if(isMobile.test(value) || isPhone.test(value)) {
			return true;
		} else {
			return false;
		}
	}
</script>

<style scoped>
	.form_label {
		margin-right: 0;
	}
	
	.btn_a {
		text-decoration: none;
	}
	
	.id_card_box {
		margin-left: 129px;
	}
</style>


// WEBPACK FOOTER //
// developer_register.vue?76b34bce